"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInternalAdminUsers = exports.useInternalAdminsIds = exports.useInternalAdminsCompaines = void 0;
var react_1 = require("react");
var moment_1 = __importDefault(require("moment"));
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("@dayone/firebase");
var firebaseApp;
var firestore;
function InternalAdminConfig(_firebaseApp) {
    firebaseApp = _firebaseApp;
    firestore = (0, firestore_1.getFirestore)(_firebaseApp);
}
exports.default = InternalAdminConfig;
/**
 * Firebase hook for getting internal admin's data.
 * This hook is for getting the companies collection data.
 * @returns Firestore internal admin's data
 *
 */
function useInternalAdminsCompaines() {
    var _this = this;
    var prepareData = function (_companies) {
        return _companies.map(function (_company) { return ({
            id: _company.id,
            companyName: (_company === null || _company === void 0 ? void 0 : _company.name) || '',
            members: (_company === null || _company === void 0 ? void 0 : _company.usersCount) || 0,
            teams: (_company === null || _company === void 0 ? void 0 : _company.branchesCount) || 0,
            announcements: (_company === null || _company === void 0 ? void 0 : _company.motdsCount) || 0,
            tasks: (_company === null || _company === void 0 ? void 0 : _company.tasksCount) || 0,
            faqs: (_company === null || _company === void 0 ? void 0 : _company.faqsCount) || 0,
            repositories: (_company === null || _company === void 0 ? void 0 : _company.repositoriesCount) || 0,
            lastActivityDate: (_company === null || _company === void 0 ? void 0 : _company.lastActivityDate)
                ? (0, moment_1.default)(_company.lastActivityDate.seconds * 1000).toISOString()
                : '',
            updatedAt: (_company === null || _company === void 0 ? void 0 : _company.updatedAt) ? (0, moment_1.default)(_company.updatedAt.seconds).toISOString() : '',
        }); });
    };
    var _a = (0, react_1.useState)([]), companies = _a[0], setCompanies = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, _companies;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 2, 3]);
                    return [4 /*yield*/, firebase_1.callable.getAllCompanyForInternalAdmin(firebaseApp)];
                case 1:
                    result = _a.sent();
                    _companies = (result.data || []);
                    setCompanies(prepareData(_companies));
                    return [3 /*break*/, 3];
                case 2:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchData();
    }, []);
    return { companies: companies, isLoading: isLoading };
}
exports.useInternalAdminsCompaines = useInternalAdminsCompaines;
/**
 * Hooks use to fetch internal admins IDs
 */
function useInternalAdminsIds() {
    var _a = (0, react_1.useState)({
        initialised: false,
        internalAdmin: null,
    }), internalAdminsData = _a[0], setInternalAdminsData = _a[1];
    (0, react_1.useEffect)(function () {
        var unsubscribe = null;
        var internalAdminsQuery = (0, firestore_1.query)((0, firestore_1.collection)(firestore, 'systems'), (0, firestore_1.where)((0, firestore_1.documentId)(), '==', 'internalAdmins'));
        unsubscribe = (0, firestore_1.onSnapshot)(internalAdminsQuery, function (querySnapshot) {
            var docs = [];
            querySnapshot.forEach(function (doc) {
                docs.push(__assign({}, doc.data()));
            });
            setInternalAdminsData({
                initialised: true,
                internalAdmin: docs[0],
            });
        });
        return function () {
            unsubscribe && unsubscribe();
        };
    }, []);
    return internalAdminsData;
}
exports.useInternalAdminsIds = useInternalAdminsIds;
function useInternalAdminUsers() {
    var _this = this;
    var prepareData = function (_users) {
        return _users.map(function (user) {
            return ({
                id: (user === null || user === void 0 ? void 0 : user.id) || '',
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                name: (user === null || user === void 0 ? void 0 : user.name) || '',
                phoneNumber: (user === null || user === void 0 ? void 0 : user.phoneNumber) || '',
                workspaces: (user === null || user === void 0 ? void 0 : user.workspaces) || '',
                createdDate: (user === null || user === void 0 ? void 0 : user.createdDate) ? (0, moment_1.default)(user.createdDate.seconds * 1000).toISOString() : '',
            });
        });
    };
    var _a = (0, react_1.useState)([]), users = _a[0], setUsers = _a[1];
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(undefined), companyId = _c[0], setCompanyId = _c[1];
    var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, _users, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, firebase_1.callable.getAllUserForInternalAdmin(firebaseApp, { companyId: companyId })];
                case 2:
                    result = _a.sent();
                    _users = (result.data || []);
                    setUsers(prepareData(_users));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchData();
    }, [companyId]);
    return { isLoading: isLoading, users: users, companyId: companyId, setCompanyId: setCompanyId };
}
exports.useInternalAdminUsers = useInternalAdminUsers;
